import { render, staticRenderFns } from "./DiscountReason.vue?vue&type=template&id=0e86daf9"
import script from "./DiscountReason.vue?vue&type=script&lang=js"
export * from "./DiscountReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports